
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as newxvrrKwm7qkG87Pds5JLAnxetAOR6jtmp1ukWIAv5qrsMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/new.vue?macro=true";
import { default as indexNL_huTLd8tBiEg8bwgI68Jf5jbM4fhak7v31mNscXS4Meta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/index.vue?macro=true";
import { default as index8GSKwBGuftgJ26AgsFt8OpU9Dm6mMZBvrTTdemMFSVcMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/ai/index.vue?macro=true";
import { default as indexe7hxsiN2XfcuarbLdoJVV3gx4PKy6ZFQGfOlDdGZumEMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/careers/index.vue?macro=true";
import { default as indexy0duvQU6Hg7F9RlsKVq_45uv4o2X_My4OwCS_45TYNHfXV0Meta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/pricing/index.vue?macro=true";
import { default as indexCZxHNrrJAGSeTJ9fpO1gxJEXCtV3G4q3w_LoT19uZOwMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/about-us/index.vue?macro=true";
import { default as saasOtsx_BM19135pT_45XsIGne_45sBJ_45kBauKQLVi863WSvJ0Meta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/solutions/saas.vue?macro=true";
import { default as zohond3Ywq06GjC1QZMqbdEMM5IE2rBxgXBJ8vZ1T9jt0EIMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/zoho.vue?macro=true";
import { default as index6O2OoJqYG1Pu1NBtIlqmx5HZExtUbshfOjhOtereotcMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/use-cases/index.vue?macro=true";
import { default as brazewIk6OV_452PS6bl91W1VcAt6YCJU6nJpBCNrct7YwWIjsMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/braze.vue?macro=true";
import { default as indexgaX48z98oRZhq_45a7I44792bqnRO_45305gaZj_PXcSSBIMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/newsletter/index.vue?macro=true";
import { default as OldindexbTROV8uhTniIMvxBUw_45N99I4S5eez9mOXEjkfZFUZ_oMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/pricing/Oldindex.vue?macro=true";
import { default as indexMhNPdOgJHK7FJyEBWk1u2mt_451PDaWybKFXPt4KMeZhYMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/talk-to-us/index.vue?macro=true";
import { default as indexV_459TQo_QiyQbdRx4YYEjHZlEza2F_45GG_45KaGp_aNOWv8Meta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/partnership/index.vue?macro=true";
import { default as indexKDmM1Yf7MpCtE32YVhDQ7fQYMz_45Ay3vVIjad9TOo_6kMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/pricing-new/index.vue?macro=true";
import { default as hubspotBV4GsxOIfq5YcRps51C0APBLDiBttat4ecV_454MKja4cMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/hubspot.vue?macro=true";
import { default as netcoreGngSihtX3_45Cz9h7F5x36tWzxRhwSHiDTx2BreLAm9PIMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/netcore.vue?macro=true";
import { default as messagingWJEfMx5MPHE9YWbn7qvroRCF7RmRuvkx5_45myLMwWNu8Meta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/messaging.vue?macro=true";
import { default as indexnolsbAM8vAjjV0iuftdb9jeuJpFFwdl_45yxe7O7xvzRsMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/cookie-policy/index.vue?macro=true";
import { default as automationoh1pl_450DTuugZIjinpo9v0nrEndw_45wYZvEa42_tvg9AMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/automation.vue?macro=true";
import { default as financialsx6GQakpfGyiKh7t5Ky_45HTRXimGnogDKlWM55qozp8oMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/solutions/financial.vue?macro=true";
import { default as logisticsVDcNrPfzXkQ6P7_KIeZ7tKBTGx9bWCYjbVW1jrMkQOQMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/solutions/logistics.vue?macro=true";
import { default as clevertapb9H8bxY3DBkhozXAtywvdXUX3G7yfI4HiHUOJz_45lTU0Meta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/clevertap.vue?macro=true";
import { default as mailchimpU2DI1b93y22UaTPqPKncHw2p_45kikTyu08v9lAPC22EkMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/mailchimp.vue?macro=true";
import { default as sendpulseso5x8eHbsYhUsuMZSsKXfY56S4E0u4IVtr_AIYxa_IkMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/sendpulse.vue?macro=true";
import { default as indexuCSXj5_45ZMpqqfrWE_45lEnFYl_45FQFPVWGv0oAnJYtLsgoMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/privacy-policy/index.vue?macro=true";
import { default as segmentationmh4NCdhIzS_FiDUQDlIOm0B7YfHROctq6ZE8DSB3WZIMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/segmentation.vue?macro=true";
import { default as customer_45ioFMo9iCVqRvcGa0MWsmnV2nwT_45HKEMNuX0IKw34cw16MMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/customer-io.vue?macro=true";
import { default as indexEfx1VW9IP_FQyHuAuiDQde4zLmNYGiS89XBDrirKkQoMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/terms-conditions/index.vue?macro=true";
import { default as customer_45analyticspBHmG_45Ohu_mVGq6dKPgOBrMRz7RkDUH0bVUIIObAEsEMeta } from "/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/customer-analytics.vue?macro=true";
export default [
  {
    name: "new",
    path: "/new",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/new.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/index.vue")
  },
  {
    name: "ai",
    path: "/ai",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/ai/index.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/careers/index.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/pricing/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/about-us/index.vue")
  },
  {
    name: "solutions-saas",
    path: "/solutions/saas",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/solutions/saas.vue")
  },
  {
    name: "comparison-zoho",
    path: "/comparison/zoho",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/zoho.vue")
  },
  {
    name: "use-cases",
    path: "/use-cases",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/use-cases/index.vue")
  },
  {
    name: "comparison-braze",
    path: "/comparison/braze",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/braze.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/newsletter/index.vue")
  },
  {
    name: "pricing-Oldindex",
    path: "/pricing/Oldindex",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/pricing/Oldindex.vue")
  },
  {
    name: "talk-to-us",
    path: "/talk-to-us",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/talk-to-us/index.vue")
  },
  {
    name: "partnership",
    path: "/partnership",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/partnership/index.vue")
  },
  {
    name: "pricing-new",
    path: "/pricing-new",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/pricing-new/index.vue")
  },
  {
    name: "comparison-hubspot",
    path: "/comparison/hubspot",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/hubspot.vue")
  },
  {
    name: "comparison-netcore",
    path: "/comparison/netcore",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/netcore.vue")
  },
  {
    name: "products-messaging",
    path: "/products/messaging",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/messaging.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/cookie-policy/index.vue")
  },
  {
    name: "products-automation",
    path: "/products/automation",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/automation.vue")
  },
  {
    name: "solutions-financial",
    path: "/solutions/financial",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/solutions/financial.vue")
  },
  {
    name: "solutions-logistics",
    path: "/solutions/logistics",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/solutions/logistics.vue")
  },
  {
    name: "comparison-clevertap",
    path: "/comparison/clevertap",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/clevertap.vue")
  },
  {
    name: "comparison-mailchimp",
    path: "/comparison/mailchimp",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/mailchimp.vue")
  },
  {
    name: "comparison-sendpulse",
    path: "/comparison/sendpulse",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/sendpulse.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/privacy-policy/index.vue")
  },
  {
    name: "products-segmentation",
    path: "/products/segmentation",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/segmentation.vue")
  },
  {
    name: "comparison-customer-io",
    path: "/comparison/customer-io",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/comparison/customer-io.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/terms-conditions/index.vue")
  },
  {
    name: "products-customer-analytics",
    path: "/products/customer-analytics",
    component: () => import("/codebuild/output/src4125225622/src/dashboard/apps/website/pages/products/customer-analytics.vue")
  }
]